<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <path
      :fill="color"
      d="M17 0c.552 0 1 .448 1 1v16c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1h16zm0 1H1v16h16V1zM5.5 10C6.88 10 8 11.12 8 12.5S6.88 15 5.5 15 3 13.88 3 12.5 4.12 10 5.5 10zm0 1c-.828 0-1.5.672-1.5 1.5S4.672 14 5.5 14 7 13.328 7 12.5 6.328 11 5.5 11zm6.553-3.724c.184-.368.71-.368.894 0l2 4c.166.333-.075.724-.447.724h-4c-.372 0-.613-.391-.447-.724zm.447 1.342L11.309 11h2.381L12.5 8.618zM8 3v5H3V3h5zM7 4H4v3h3V4z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
